module.exports = __webpack_public_path__ + "img/qingbianfufm.dc9aadd2.jpg";